import { Switch, styled } from "@mui/material";

const PillSwitch = styled(Switch)(({ theme }) => ({
  padding: 0,
  width: '40px',
  height: '20px',
  borderRadius: '10px',
  '& .MuiSwitch-thumb': {
    width: '14px',
    height: '14px',
    borderRadius: '50%',
    transform: 'translateY(-1px)',
    color: "white !important"
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    transform: 'translateX(20px)', // Move switch thumb to the right when checked
    '&.Mui-disabled': {
      color: theme.palette.grey[400],
      '& + .MuiSwitch-thumb': {
        backgroundColor: theme.palette.grey[400],
      },
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#376AFA !important', 
    opacity:'1'
  },
  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': {
    backgroundColor: '#376AFA !important',  
    opacity:'1'
  },
  '& .MuiSwitch-switchBase + .MuiSwitch-track': {
    backgroundColor: '#D6D8E5', 
  },
}));

export default PillSwitch